import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMaxIcontext = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8,7 L11,7 L11,10 L13,10 L13,7 L16,7 L12,3 L8,7 Z M4,19 L4,21 L20,21 L20,19 L4,19 Z M8.709,14.436 L8.709,12.889 L8.653,12.889 L7.624,15.402 L6.595,12.889 L6.539,12.889 L6.539,14.436 L6.539,16.886 L6,16.886 L6,12 L6.756,12 L7.617,14.156 L7.659,14.156 L8.52,12 L9.248,12 L9.248,16.886 L8.709,16.886 L8.709,14.436 Z M13.466,16.886 L13.053,15.493 L11.338,15.493 L10.925,16.886 L10.316,16.886 L11.814,12 L12.591,12 L14.089,16.886 L13.466,16.886 Z M12.227,12.623 L12.164,12.623 L11.478,14.982 L12.913,14.982 L12.227,12.623 Z M18.699,16.886 L18.034,16.886 L17.453,15.913 L16.809,14.849 L16.781,14.849 L16.116,15.913 L15.5,16.886 L14.856,16.886 L16.452,14.394 L14.947,12 L15.612,12 L16.179,12.945 L16.788,13.932 L16.816,13.932 L17.418,12.945 L18.006,12 L18.65,12 L17.138,14.387 L18.699,16.886 Z",
		fill: "currentColor"
	})
});
export default SvgMaxIcontext;
